import styles from "./AboutTimeline.module.css";
import portrait from "../assets/about.jpg"; 
import bg from "../assets/about_background.JPG";    

export default function About() {
  return (
    <section className={styles.aboutSection}>
      
      {/* Header background */}
      <div className={styles.bgImage}>
        <h1 className={styles.title}>{`{About me}`}</h1>
      </div>

      {/* Center portrait */}
      <div className={styles.portraitWrapper}>
        <div className={styles.backBlock}></div>
        <img src={portrait} alt="Milagros" className={styles.portrait} />
      </div>

      {/* Three columns */}
      <div className={styles.columns}>
        <div className={styles.column}>
          <h2>+ My Career</h2>
          <p>
            I’m a software developer graduated at Politecnico di Milano, 
            now pursuing a Master’s in Computer Science and Engineering.
          </p>
          <p>
            I enjoy exploring different areas of software development, 
            from deep learning to web development, where I can combine 
            logic and creativity.
          </p>
        </div>

        <div className={styles.column}>
          <h2>+ My Hobbies</h2>
          <p>
            I love photography, especially film, and the calm rhythm of slow living.
          </p>
          <p>
            At the same time, I’m always eager for new experiences, anything 
            that lets me learn, explore, and capture life in different ways.
          </p>
        </div>

        <div className={styles.column}>
          <h2>+ My Values</h2>
          <p>
            Curiosity, care, and clarity guide the way I work. I enjoy 
            understanding problems deeply, building thoughtful solutions, 
            and collaborating with others.
          </p>
          <p>
            I value clean design, clean code, and the kind of work that 
            makes everyday life a bit easier for someone.
          </p>
        </div>
      </div>

    </section>
  );
}
